import { Skeleton } from "src/components/skeleton/Skeleton";

export function SkeletonCard() {
    return (
        <Skeleton className="aspect-square w-full rounded-[8px]" />
    )
}